module.exports = __webpack_public_path__ + "plot-generator/static/media/logos_1p.1c71ed4a.png";